import type { CartItem } from '@/types/cart';
import type { CustomerLocationDto } from '@/types';

export function formatLocationName(location: Pick<CustomerLocationDto, 'name' | 'country'>): string {
    const name = location.name.trim();
    const country = location.country?.trim();
    return country && !name.toLocaleLowerCase().includes(country.toLocaleLowerCase())
        ? `${name}, ${country}`
        : name;
}

/** Cart item locations, not the catalogue filter, define the booking. */
export function getBookingDestination(items: Pick<CartItem, 'locationId' | 'locationName'>[]) {
    const ids = new Set(items.map(item => item.locationId).filter(Boolean));
    const isValid = items.length > 0 && ids.size === 1 && items.every(item => !!item.locationId);
    const locationId = isValid ? items[0].locationId : undefined;
    return {
        isValid,
        isMixed: ids.size > 1,
        locationId,
        locationName: isValid ? items.find(item => item.locationName)?.locationName : undefined,
    };
}
